(function(){

var MODELS_URL='https://cdn.jsdelivr.net/gh/justadudewhohacks/face-api.js@0.22.2/weights';
var FA_URL='https://cdn.jsdelivr.net/npm/face-api.js@0.22.2/dist/face-api.min.js';

var video,canvas,ctx,stream,animId,frameImg,modelsLoaded=false,detecting=false;

// ── Carousel CSS ─────────────────────────────────────────────────────────
function injectCarouselCSS(){
  if(document.getElementById('urc-cr-st')) return;
  var s=document.createElement('style');s.id='urc-cr-st';
  s.textContent=
    '.urc-cr{display:flex;flex-direction:row;flex-wrap:nowrap;gap:10px;padding:10px 18px;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scrollbar-width:none;touch-action:pan-x}'+
    '.urc-cr::-webkit-scrollbar{display:none}'+
    '.urc-cr-f{flex-shrink:0;cursor:pointer;width:64px;text-align:center}'+
    '.urc-cr-f img{width:56px;height:56px;border-radius:9px;object-fit:cover;border:2px solid rgba(201,168,76,0.15);transition:border-color 0.2s,transform 0.15s;display:block;margin:0 auto}'+
    '.urc-cr-f:hover img,.urc-cr-f.on img{border-color:#C9A84C;transform:scale(1.07)}'+
    '.urc-cr-f span{display:block;font-size:8px;color:rgba(249,247,243,0.4);margin-top:4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-family:"DM Sans",sans-serif}'+
    '.urc-cr-f.on span{color:#C9A84C}';
  document.head.appendChild(s);
}

// ── Render carousel ───────────────────────────────────────────────────────
function renderCarousel(containerId, activeHandle, onSwitch){
  var frames=window.URCTRY_FRAMES||[];
  var wrap=document.getElementById(containerId);
  if(!wrap) return;
  if(frames.length<=1){wrap.style.display='none';return;}
  injectCarouselCSS();
  wrap.className='urc-cr';
  wrap.innerHTML='';
  frames.forEach(function(f){
    var div=document.createElement('div');
    div.className='urc-cr-f'+(f.handle===activeHandle?' on':'');
    div.innerHTML='<img src="'+f.img+'" alt="'+f.title+'" loading="lazy"><span>'+f.title+'</span>';
    div.onclick=function(){
      wrap.querySelectorAll('.urc-cr-f').forEach(function(d){d.classList.remove('on');});
      div.classList.add('on');
      onSwitch(f);
    };
    wrap.appendChild(div);
  });
  var on=wrap.querySelector('.on');
  if(on) setTimeout(function(){on.scrollIntoView({inline:'center',block:'nearest',behavior:'smooth'});},100);
  // Mouse drag scroll for non-touch screens
  if(!wrap._dragInit){
    wrap._dragInit=true;
    var isDown=false,startX,scrollLeft;
    wrap.addEventListener('mousedown',function(e){isDown=true;startX=e.pageX-wrap.offsetLeft;scrollLeft=wrap.scrollLeft;wrap.style.cursor='grabbing';});
    wrap.addEventListener('mouseleave',function(){isDown=false;wrap.style.cursor='';});
    wrap.addEventListener('mouseup',function(){isDown=false;wrap.style.cursor='';});
    wrap.addEventListener('mousemove',function(e){if(!isDown)return;e.preventDefault();var x=e.pageX-wrap.offsetLeft;wrap.scrollLeft=scrollLeft-(x-startX);});
  }
}

// ── Load face-api.js ──────────────────────────────────────────────────────
function loadFaceApi(cb){
  if(window.faceapi){cb();return;}
  var s=document.createElement('script');
  s.src=FA_URL;s.onload=cb;
  s.onerror=function(){setStatus('Face detection unavailable in this browser');};
  document.head.appendChild(s);
}

// ── Load models ───────────────────────────────────────────────────────────
function loadModels(cb){
  if(modelsLoaded){cb();return;}
  setStatus('Loading face detection...');
  Promise.all([
    faceapi.nets.tinyFaceDetector.loadFromUri(MODELS_URL),
    faceapi.nets.faceLandmark68TinyNet.loadFromUri(MODELS_URL)
  ]).then(function(){modelsLoaded=true;cb();})
  .catch(function(){setStatus('Could not load face detection models');});
}

// ── Camera ────────────────────────────────────────────────────────────────
function startCamera(cb){
  if(!navigator.mediaDevices||!navigator.mediaDevices.getUserMedia){
    setStatus('Camera not supported on this browser');return;
  }
  navigator.mediaDevices.getUserMedia({video:{facingMode:'user',width:{ideal:640},height:{ideal:480}}})
  .then(function(s){
    stream=s;video.srcObject=s;
    video.onloadedmetadata=function(){
      canvas.width=video.videoWidth;canvas.height=video.videoHeight;cb();
    };
  }).catch(function(e){
    setStatus(e.name==='NotAllowedError'?'Camera permission denied. Please allow camera access.':'Could not access camera.');
  });
}

// ── Load frame image ──────────────────────────────────────────────────────
function loadFrameImg(src,cb){
  var img=new Image();img.crossOrigin='anonymous';
  img.onload=function(){frameImg=img;cb();};
  img.onerror=function(){frameImg=null;cb();};
  img.src=src||'';
}

// ── Draw frame ────────────────────────────────────────────────────────────
function drawFrame(landmarks){
  var pts=landmarks.positions;
  var lx=pts[36].x,ly=pts[36].y,rx=pts[45].x,ry=pts[45].y;
  var dx=rx-lx,dy=ry-ly;
  var eyeDist=Math.sqrt(dx*dx+dy*dy);
  var angle=Math.atan2(dy,dx);
  var fw=eyeDist*1.78;
  var fh=fw*0.38;
  var cx=(lx+rx)/2;
  var cy=(ly+ry)/2+eyeDist*0.12;
  ctx.save();ctx.translate(cx,cy);ctx.rotate(angle);
  if(frameImg){
    ctx.drawImage(frameImg,-fw/2,-fh/2,fw,fh);
  } else {
    ctx.strokeStyle='rgba(201,168,76,0.9)';ctx.lineWidth=2;
    var r=eyeDist*0.42;
    ctx.beginPath();ctx.arc(-eyeDist*0.3,0,r,0,Math.PI*2);ctx.stroke();
    ctx.beginPath();ctx.arc(eyeDist*0.3,0,r,0,Math.PI*2);ctx.stroke();
    ctx.beginPath();ctx.moveTo(-eyeDist*0.3+r*0.85,0);ctx.lineTo(eyeDist*0.3-r*0.85,0);ctx.stroke();
  }
  ctx.restore();
}

// ── Detection loop ────────────────────────────────────────────────────────
function detect(){
  if(!detecting) return;
  var opts=new faceapi.TinyFaceDetectorOptions({inputSize:320,scoreThreshold:0.4});
  faceapi.detectSingleFace(video,opts).withFaceLandmarks(true)
  .then(function(result){
    ctx.clearRect(0,0,canvas.width,canvas.height);
    if(result){setStatus('');drawFrame(result.landmarks);}
    else{setStatus('No face detected - look at the camera');}
    animId=requestAnimationFrame(detect);
  }).catch(function(){animId=requestAnimationFrame(detect);});
}

// ── Helpers ───────────────────────────────────────────────────────────────
function setStatus(msg){
  var el=document.getElementById('urc-try-status');
  if(el){el.textContent=msg;el.style.display=msg?'block':'none';}
}

// ── Hide/restore page elements ────────────────────────────────────────────
function hidePageElements(){
  document.body.style.overflow='hidden';
  var hdr=document.querySelector('[id*="header_section"]');
  if(hdr){hdr.setAttribute('data-urc-z',hdr.style.zIndex||'');hdr.style.zIndex='-1';}
  var bar=document.getElementById('urc-bar');
  if(bar){bar.setAttribute('data-urc-d',bar.style.display||'');bar.style.display='none';}
}
function restorePageElements(){
  document.body.style.overflow='';
  var hdr=document.querySelector('[id*="header_section"]');
  if(hdr){hdr.style.zIndex=hdr.getAttribute('data-urc-z')||'';hdr.removeAttribute('data-urc-z');}
  var bar=document.getElementById('urc-bar');
  if(bar){bar.style.display=bar.getAttribute('data-urc-d')||'';bar.removeAttribute('data-urc-d');}
}

// ── Product page API ──────────────────────────────────────────────────────
window.URCTRY={
  open:function(){
    if(!window._urcTryHistory){
      history.pushState({urcTry:true},'','');
      window._urcTryHistory=true;
    }
    var ov=document.getElementById('urc-try-ov');
    video=document.getElementById('urc-try-video');
    canvas=document.getElementById('urc-try-canvas');
    ctx=canvas.getContext('2d');
    if(!ov||!video||!canvas) return;
    ov.style.display='flex';
    requestAnimationFrame(function(){ov.classList.add('go');});
    hidePageElements();
    setStatus('Starting camera...');
    var src=window.URCTRY_IMG&&window.URCTRY_IMG.length>10?window.URCTRY_IMG:(window.URCTRY_IMG_FALLBACK||'');
    loadFrameImg(src,function(){
      loadFaceApi(function(){
        loadModels(function(){
          startCamera(function(){
            setStatus('Detecting face...');detecting=true;detect();
          });
        });
      });
    });
    renderCarousel('urc-try-carousel',window.URCTRY_CURRENT||'',function(f){
      var s2=f.tryon&&f.tryon.length>10?f.tryon:f.img;
      loadFrameImg(s2,function(){});
      var t=document.getElementById('urc-try-fname');if(t)t.textContent=f.title;
      var h=document.getElementById('urc-try-title');if(h)h.textContent=f.title;
      var l=document.getElementById('urc-try-viewlink');if(l)l.href=f.url;
    });
  },
  close:function(){
    detecting=false;
    if(animId)cancelAnimationFrame(animId);
    if(stream)stream.getTracks().forEach(function(t){t.stop();});
    stream=null;
    var ov=document.getElementById('urc-try-ov');
    if(ov){ov.classList.remove('go');setTimeout(function(){ov.style.display='none';},300);}
    if(ctx&&canvas)ctx.clearRect(0,0,canvas.width,canvas.height);
    restorePageElements();
    window._urcTryHistory=false;
  }
};

window.addEventListener('popstate',function(e){
  if(e.state&&e.state.urcTry===true) return;
  var ov=document.getElementById('urc-try-ov');
  if(ov&&ov.classList.contains('go')){window._urcTryHistory=false;URCTRY.close();}
  if(e.state&&e.state.urcGal===true) return;
  var gov=document.getElementById('urc-gal-ov');
  if(gov&&gov.style.opacity==='1'){window._urcGalHistory=false;if(window.URCGalTry)URCGalTry.close();}
});

// ── Hide/show bubble when configurator opens ─────────────────────────────
(function(){
  function setBubble(show){
    var b=document.getElementById('urc-try-bubble');
    if(b) b.style.display=show?'flex':'none';
  }
  // Watch urc-modal for class changes
  var obs=new MutationObserver(function(){
    var m=document.getElementById('urc-modal');
    if(m) setBubble(!m.classList.contains('on'));
  });
  function watch(){
    var m=document.getElementById('urc-modal');
    if(!m){setTimeout(watch,500);return;}
    obs.observe(m,{attributes:true,attributeFilter:['class']});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',watch);}
  else{watch();}
})();

// ── Sync bar image with Horizon sticky button ─────────────────────────────
(function(){
  function syncBarImg(){
    var src=document.querySelector('.sticky-add-to-cart__image-img');
    var bar=document.querySelector('.urc-bar-img');
    if(!src||!bar) return;
    bar.src=src.src.replace(/(\?|&)width=\d+/,'$1width=100');
  }
  function watch(){
    var h=document.querySelector('.sticky-add-to-cart__image-img');
    if(!h){setTimeout(watch,500);return;}
    new MutationObserver(function(){syncBarImg();}).observe(h,{attributes:true,attributeFilter:['src','srcset']});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',watch);}
  else{watch();}
})();

// ── Patch product add-to-cart button ──────────────────────────────────────
(function(){
  function patch(){
    var btn=document.querySelector('button[name="add"]');
    if(!btn) return;
    btn.innerHTML='&#9819; Build Your Pair';
    btn.setAttribute('type','button');
    btn.style.animation='urc-pulse 3.5s ease-in-out infinite';
    btn.onclick=function(e){e.preventDefault();e.stopPropagation();if(window.URC)URC.open();};
    if(!document.getElementById('urc-btn-sub')){
      var sub=document.createElement('div');sub.id='urc-btn-sub';
      sub.style.cssText='text-align:center;font-size:11px;color:rgba(201,168,76,0.55);margin-top:5px;letter-spacing:0.04em;';
      sub.textContent='Frames + Lenses Included';
      btn.parentNode.insertBefore(sub,btn.nextSibling);
    }
  }
  function init(){
    patch();
    var form=document.querySelector('form[action="/cart/add"]');
    if(form){
      new MutationObserver(function(){
        var b=document.querySelector('button[name="add"]');
        if(b&&b.innerHTML.indexOf('Build')===-1)patch();
      }).observe(form,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{init();}
})();

// ── Gallery API ───────────────────────────────────────────────────────────
window.URCGalTry=(function(){
  var gvid,gcvs,gctx,gstream,ganId,gframeImg,gdetecting=false;
  function gStatus(m){var e=document.getElementById('urc-gal-status');if(e){e.textContent=m;e.style.display=m?'block':'none';}}
  function gLoadImg(src,cb){var i=new Image();i.crossOrigin='anonymous';i.onload=function(){gframeImg=i;cb();};i.onerror=function(){gframeImg=null;cb();};i.src=src||'';}
  function gDetect(){
    if(!gdetecting)return;
    var opts=new faceapi.TinyFaceDetectorOptions({inputSize:320,scoreThreshold:0.4});
    faceapi.detectSingleFace(gvid,opts).withFaceLandmarks(true).then(function(r){
      gctx.clearRect(0,0,gcvs.width,gcvs.height);
      if(r){
        gStatus('');
        var pts=r.landmarks.positions;
        var lx=pts[36].x,ly=pts[36].y,rx=pts[45].x,ry=pts[45].y;
        var dx=rx-lx,dy=ry-ly,ed=Math.sqrt(dx*dx+dy*dy),ang=Math.atan2(dy,dx);
        var fw=ed*1.78,fh=fw*0.38,cx=(lx+rx)/2,cy=(ly+ry)/2+ed*0.12;
        gctx.save();gctx.translate(cx,cy);gctx.rotate(ang);
        if(gframeImg){gctx.drawImage(gframeImg,-fw/2,-fh/2,fw,fh);}
        gctx.restore();
      } else{gStatus('No face detected - look at the camera');}
      ganId=requestAnimationFrame(gDetect);
    }).catch(function(){ganId=requestAnimationFrame(gDetect);});
  }
  function start(src,title,url,handle){
    gvid=document.getElementById('urc-gal-video');
    gcvs=document.getElementById('urc-gal-canvas');
    gctx=gcvs.getContext('2d');
    var titleEl=document.getElementById('urc-gal-modal-title');
    var nameEl=document.getElementById('urc-gal-name');
    var linkEl=document.getElementById('urc-gal-viewlink');
    if(titleEl)titleEl.textContent=title;
    if(nameEl)nameEl.textContent=title;
    if(linkEl)linkEl.href=url;
    gLoadImg(src,function(){
      navigator.mediaDevices.getUserMedia({video:{facingMode:'user'}}).then(function(s){
        gstream=s;gvid.srcObject=s;
        gvid.onloadedmetadata=function(){
          gcvs.width=gvid.videoWidth;gcvs.height=gvid.videoHeight;
          gStatus('Detecting face...');gdetecting=true;gDetect();
        };
      }).catch(function(){gStatus('Camera permission denied.');});
    });
    renderCarousel('urc-gal-carousel',handle,function(f){
      var s2=f.tryon&&f.tryon.length>10?f.tryon:f.img;
      gLoadImg(s2,function(){});
      var t=document.getElementById('urc-gal-modal-title');if(t)t.textContent=f.title;
      var n=document.getElementById('urc-gal-name');if(n)n.textContent=f.title;
      var l=document.getElementById('urc-gal-viewlink');if(l)l.href=f.url;
    });
  }
  return {
    open:function(metaSrc,fallback,title,url,handle){
      var src=metaSrc&&metaSrc.length>10?metaSrc:fallback;
      if(!window._urcGalHistory){
        history.pushState({urcGal:true},'','');
        window._urcGalHistory=true;
      }
      var ov=document.getElementById('urc-gal-ov');
      ov.style.display='flex';requestAnimationFrame(function(){ov.style.opacity='1';});
      hidePageElements();
      gStatus('Starting camera...');
      if(window.faceapi&&window.faceapi.nets.tinyFaceDetector.params){
        start(src,title,url,handle);
      } else {
        gStatus('Loading detection...');
        var sc=document.createElement('script');sc.src=FA_URL;
        sc.onload=function(){
          Promise.all([
            faceapi.nets.tinyFaceDetector.loadFromUri(MODELS_URL),
            faceapi.nets.faceLandmark68TinyNet.loadFromUri(MODELS_URL)
          ]).then(function(){start(src,title,url,handle);});
        };
        document.head.appendChild(sc);
      }
    },
    close:function(){
      gdetecting=false;if(ganId)cancelAnimationFrame(ganId);
      if(gstream)gstream.getTracks().forEach(function(t){t.stop();});gstream=null;
      var ov=document.getElementById('urc-gal-ov');
      if(ov){ov.style.opacity='0';setTimeout(function(){ov.style.display='none';},300);}
      if(gctx&&gcvs)gctx.clearRect(0,0,gcvs.width,gcvs.height);
      restorePageElements();
      window._urcGalHistory=false;
    }
  };
})();

})();